import { Controller } from "@hotwired/stimulus"

// Live, client-side preview of white-label report branding. Approximation only —
// the authoritative output comes from the server-rendered "Download sample report".
export default class extends Controller {
  static targets = [
    "bar", "logo", "logoInput",
    "primary", "secondary",
    "companyName", "companyNamePreview",
    "tag", "tagPreview",
    "attribution", "footerPreview"
  ]

  connect() {
    this.update()
  }

  update() {
    const primary = this.hasPrimaryTarget ? this.primaryTarget.value : "#0E7490"
    const secondary = this.hasSecondaryTarget ? this.secondaryTarget.value : "#164E63"
    const company = this.hasCompanyNameTarget ? this.companyNameTarget.value.trim() : ""
    const tag = this.hasTagTarget ? this.tagTarget.value.trim() : ""
    const showAttribution = this.hasAttributionTarget ? this.attributionTarget.checked : true

    this.barTargets.forEach((el) => { el.style.backgroundColor = primary })

    if (this.hasCompanyNamePreviewTarget) {
      this.companyNamePreviewTarget.textContent = company || "Your Company"
      this.companyNamePreviewTarget.style.color = primary
    }
    if (this.hasTagPreviewTarget) {
      this.tagPreviewTarget.textContent = tag
      this.tagPreviewTarget.style.color = secondary
    }
    if (this.hasFooterPreviewTarget) {
      this.footerPreviewTarget.textContent = showAttribution ? "Generated by salaries.co.nz" : company
    }
  }

  previewLogo() {
    const file = this.logoInputTarget.files && this.logoInputTarget.files[0]
    if (!file) { this.showCompanyName(); return }

    const reader = new FileReader()
    reader.onload = (event) => {
      if (!this.hasLogoTarget) return
      this.logoTarget.src = event.target.result
      this.logoTarget.classList.remove("hidden")
      if (this.hasCompanyNamePreviewTarget) this.companyNamePreviewTarget.classList.add("hidden")
    }
    reader.readAsDataURL(file)
  }

  showCompanyName() {
    if (this.hasLogoTarget) this.logoTarget.classList.add("hidden")
    if (this.hasCompanyNamePreviewTarget) this.companyNamePreviewTarget.classList.remove("hidden")
  }
}
